import React from 'react';
import '../../ProductBase.css';
import './index.css';

import { Link, useNavigate } from 'react-router-dom';

import { getProductTypeDisplayName } from '../../utils/productUtils';
import { ProductType } from '../../context/CartContext';




// Sports

import product_sports_football_jersey_name_number_pendant1 from '../../assets/images/sports/product_sports_football_jersey_name_number_pendant1.webp';

// Locals
import localStreetSignsSummary from '../../assets/images/locals/product_local_street_sign_summary.webp';

// StoreFront
import productStoreFrontCannedSoda from '../../assets/images/storefront/product_storefront_canned_soda.svg';

// SnapCharms
const product_default_snapcharm = '/images/snapcharms/standard_bunny1.webp';

const Shop: React.FC = () => {
  const navigate = useNavigate();

  const handleSnapCharmsClick = () => {
    navigate('/shop/snapcharms');
  };

  const handleSportsClick = () => {
    navigate('/shop/sports');
  };

  const handleLocalsClick = () => {
    navigate('/shop/locals');
  };

  const handleStoreFrontClick = () => {
    navigate('/shop/storefront');
  };

  return (
    <div className="shop-container">      
      {/* Category Cards */}
      <div className="products-grid">
                <div className="product-card" onClick={handleStoreFrontClick}>
          <h2 className="product-category">{getProductTypeDisplayName(ProductType.StoreFront)}</h2>
          <div className="product-image-wrapper">
            <img
              src={productStoreFrontCannedSoda}
              alt="StoreFront snacks and drinks"
              className="product-image"
            />
          </div>
          <div className="product-info">
            <div className="product-actions">
              <button onClick={handleStoreFrontClick} className="detail-button">
                View Collection
              </button>
            </div>
            <p className="product-description">On Site?  Grab simple snacks and drinks like canned soda and chips.</p>
          </div>
        </div>
        <div className="product-card" onClick={handleSnapCharmsClick}>
          <h2 className="product-category">{getProductTypeDisplayName(ProductType.SNAPCHARM)}</h2>
          <div className="product-image-wrapper">
            <img 
              src={product_default_snapcharm} 
              alt="SnapCharms Collection" 
              className="product-image" 
            />
          </div>
          <div className="product-info">
          <div className="product-actions">
              <button onClick={handleSnapCharmsClick} className='detail-button'>
                View Collection
              </button>
            </div>
            <p className="product-description">Browse our collection of adorable SnapCharms</p>
          </div>
        </div>
        
        <div className="product-card" onClick={handleSportsClick}>
          <h2 className="product-category">{getProductTypeDisplayName(ProductType.SPORTS)}</h2>
          <div className="product-image-wrapper">
            <img 
              src={product_sports_football_jersey_name_number_pendant1} 
              alt="Sports Collection" 
              onClick={handleSportsClick}
              className="product-image" 
            />
          </div>
          <div className="product-info">
          <div className="product-actions">
              <button onClick={handleSportsClick} className='detail-button'>
                View Collection
              </button>
            </div>
          </div>
          <p className="product-description">Customize with your name, number, and team name !</p>

        </div>
        
        <div className="product-card" onClick={handleLocalsClick}>
          <h2 className="product-category">Locally Themed Products</h2>
          <div className="product-image-wrapper locals-images">
            <div className="locals-image-container">
              <img 
                src={localStreetSignsSummary} 
                alt="Local Signs" 
                className="locals-image" 
              />
            </div>
          </div>
          <div className="product-info">
          <div className="product-actions">
            <button onClick={handleLocalsClick} className='detail-button'>
              View Collection
            </button>
          </div>
            <p className="product-description">Street Signs with authentic samples from the local area.  Choose from a wide selection or even customize your own !</p>

          </div>
        </div>


      </div>

      {/* Custom Print Request Section */}

      <div className="custom-print-section">
      <h2>Don't See What You're Looking For?</h2>
      <p>
        Send us your customization request for a 3D printed item. It can be jewelry,
        a magnet, or almost any concept we can work on together.
      </p>

      <Link to="/contact" className="detail-button custom-print-button">
        Request Customized Print
      </Link>
    </div>

    </div>
  );
};

export default Shop;
